import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
  height: calc(100vh - 32px);
`

export const Header = styled.div`
  flex-shrink: 0;
  padding-bottom: ${props => props.theme.spacing.sp16};
  border-bottom: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
`

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Steps = styled.ol`
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
`

export const HideHeaderSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};
  padding-top: ${props => props.theme.spacing.sp24};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
`

export const HideHeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const Footer = styled.div`
  flex-shrink: 0;
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp24} 0 ${props => props.theme.spacing.sp8};
  border-top: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
`

export const PermissionAlert = styled.div`
  flex-shrink: 0;

  > div {
    margin-top: 0;
  }
`
